/* eslint-disable operator-linebreak */
/* eslint-disable implicit-arrow-linebreak */
/* eslint-disable no-return-assign */
import React from 'react';
import ReactDOM from 'react-dom';
import { styled } from 'twin.macro';

const ModalHeader = styled.div`
  display: flex;
  justify-content: space-between;
  h1 {
    font-size: 22px;
    color: #7687c2;
    font-weight: 700;
    font-family: 'Arial Regular', Arial, sans-serif;
  }
`;

const ModalBody = styled.div`
  font-family: 'Arial Regular', Arial, sans-serif;
  margin-top: 30px;
  position: relative;
  ::after {
    content: '';
    display: block;
    clear: both;
    background-image: url('/img/settings-modal.svg');
    width: 116px;
    height: 187px;
    background-repeat: no-repeat;
    position: absolute;
    right: 0;
    bottom: 0;
  }
  .copy {
    font-size: 18px;
    color: #363636;
    & > ul {
      list-style-type: disc;
      list-style-position: inside;
    }
  }
`;

const WonderSettings = ({ settings }) => {
  const modalContent = (
    <div
      className="modal fade"
      id="wonder-settings-modal"
      tabIndex="-1"
      role="dialog"
      aria-labelledby="wonder-settings-modal"
      aria-hidden="true"
    >
      <div
        className="modal-dialog modal-dialog-centered"
        role="document"
        style={{ maxWidth: '800px' }}
      >
        <div className="modal-content">
          <div
            className="custom__modal__content"
            style={{ borderRadius: '10px', border: '2px solid #7687c2' }}
          >
            <ModalHeader>
              <h1>{settings?.tooltipTitle}</h1>
              <a href="" className="custom__modal__close" data-dismiss="modal">
                <img src="/img/plus-icon.svg" alt="" />
              </a>
            </ModalHeader>
            <ModalBody>
              <div
                className="copy"
                dangerouslySetInnerHTML={{
                  __html: settings?.tooltipCopy,
                }}
              />
            </ModalBody>
          </div>
        </div>
      </div>
    </div>
  );

  if (typeof document === 'undefined') return null;

  return ReactDOM.createPortal(modalContent, document.body);
};

export default WonderSettings;
